export default __webpack_public_path__ + "static/media/dc.20340cd4.png";